<template>
  <div class="make-job-post">
    <div class="control-width mx-auto">
      <div class="p-4 p-md-5 border shadow-sm add-rounded">
        <h4 class="mb-3 font-weight-bold kova-text">Select Job role</h4>

        <a-select
          class="w-100 mt-4 mb-5"
          size="large"
          v-model="title"
          placeholder="What skills are required"
        >
          <a-select-option v-for="skill in skills" :key="skill">{{
            skill
          }}</a-select-option>
        </a-select>

        <h6 class="mt-3 font-weight-bold mb-4 text-left">
          Provide job description below
        </h6>

        <!-- <vue-editor
          id="editor"
          useCustomImageHandler
          :editorToolbar="customToolbar"
          @image-added="handleImageAdded"
          v-model="description"
          placeholder="Job Description here"
        ></vue-editor> -->

        <a-textarea
          placeholder="Job description here"
          class="m-auto w-100"
          v-model="description"
          :rows="4"
        />

        <div class="container-fluid px-0 px-md-4 mb-5 mt-5">
          <div class="row">
            <div class="col text-left">
              <button
                class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded"
                v-on:click="goBack"
              >
                Back
              </button>
            </div>
            <div class="col text-right">
              <button
                class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded"
                v-on:click="next"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right kova-text pt-3 mr-4 mb-5"></div>
    </div>
  </div>
</template>
<script>
/* import { VueEditor } from "vue2-editor"; */

export default {
  name: "job-post",
  data() {
    return {
      skills: [
        "Android Developer",
        "IOS Developer",
        "Data Engineer",
        "Full-Stack Engineer",
        "Front-end Engineer",
        "Back-end Engineer",
        "UI/UX Designer",
        "Artificial Intelligence",
        "Blockchain Engineer",
        "DevOps Engineer"
      ],
      title: this.$store.state.fcjob.fcjobData.title,
      description: this.$store.state.fcjob.fcjobData.description,
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["code-block"]
      ]
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    next() {
      const { title, description } = this;
      this.$store.commit("fcjob/updateFcJob", {
        title,
        description
      });
      this.$router.push("job-stack");
    },
    skip() {
      this.$router.push("job-stack");
    }
  }
};
</script>
<style scoped>
.control-width {
  width: 600px;
}
.input-title {
  font-size: 15px;
}
@media (min-width: 768px) and (max-width: 991px) {
}
@media (max-width: 767px) {
  .control-width {
    width: 500px;
  }
}
@media (max-width: 550px) {
  .control-width {
    width: 98%;
  }
}
</style>
